package util

import kotlinx.browser.window
import org.w3c.dom.events.MouseEvent
import util.MouseManager.normalizedMouseX
import util.MouseManager.normalizedMouseY

/**
 * Fetches the mouse position via the event and stores it in the [normalizedMouseX] and [normalizedMouseY] properties.
 */
object MouseManager {

    /**
     * Normalized x-coordinate of the mouse position (0 to 1, where 0 is leftmost and 1 is rightmost).
     */
    var normalizedMouseX = 0.0; private set

    /**
     * Normalized y-coordinate of the mouse position (0 to 1, where 0 is topmost and 1 is bottommost).
     */
    var normalizedMouseY = 0.0; private set

    /**
     * Unmodified x-coordinate of the mouse position.
     */
    var mouseX = 0.0; private set

    /**
     * Unmodified y-coordinate of the mouse position.
     */
    var mouseY = 0.0; private set


    init {
        window.addEventListener("mousemove", {
            // update mouseX and mouseY
            it as MouseEvent

            mouseX = it.clientX.toDouble()
            mouseY = it.clientY.toDouble()

            normalizedMouseX = it.clientX.toDouble() / window.innerWidth
            normalizedMouseY = it.clientY.toDouble() / window.innerHeight
        })
        // part of the viewer fix for iOS
        // (mousemove doesn't fire on iOS/Safari)
        window.addEventListener("pointerdown", {
            // update mouseX and mouseY
            it as MouseEvent

            mouseX = it.clientX.toDouble()
            mouseY = it.clientY.toDouble()

            normalizedMouseX = it.clientX.toDouble() / window.innerWidth
            normalizedMouseY = it.clientY.toDouble() / window.innerHeight
        })
    }
}